/* eslint-disable no-shadow */
/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable max-len */

import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PRESENCE_ENUMS } from './enums/presenceEnums';
import { setAudioCall, setAudioInProgress, setCallInProgress, setConnectedDevices, setConnectedVideoDevices, setConnectionState, setRoomModeView, setselectedDeviceId, setSelectedVideoDeviceId, setVideoCall, setWebcamInProgress } from '../redux/CallsRedux';
import { getTimeDifference } from './HelperContent';
import { getConectedDevices, updateDeviceData } from '../utils/CollaborationUtils';
import { addDocToSubcollection, calldbListener, getDocByDocumentId, removeUserOnlineStatus, updateDocAndDeleteSubcollection, updateDocByDocumentId } from '../utils/Firebase/firebaseQuery';
import { firebaseRealtimeDB } from '../utils/Firebase/useFirebase';
import { ref, get } from 'firebase/database';
import { setCallDetails } from '../redux/PresenceRedux';
import { declineGroupCallAPI, updateCallDetailsAPI, updatePresenceStatus } from '../containers/actions/presence_actions';
import { store } from '../redux/store';
import { toast } from 'react-toastify';

// const iceServers = [ {
// 	urls : 'stun:stun.instavc.com:19302'
// }, {
// 	urls : [
// 		'turn:turn.instavc.com:443?transport=tcp',
// 		'turn:turn.instavc.com:443?transport=udp'
// 	],
// 	credential : 'admin123',
// 	username   : 'admin'
// } ];

const configuration = {
	iceServers : [
		{ urls: 'stun:stun.instavc.com:19302' },
		{
			urls       : 'turn:awsturn.instavc.com:443?transport=udp',
			username   : 'admin',
			credential : 'admin123'
		},
		{
			urls       : 'turn:awsturn.instavc.com:443?transport=tcp',
			username   : 'admin',
			credential : 'admin123'
		}
	]
};

export const config = {
	invccaptchasitekey   : '6Ld17rkaAAAAAGMHwTxu8FePEdu-lQMxAnZj0QDX',
	channelCount         : 1, // 1 for Provides sufficient quality for most use case, 2 for If you detect a higher-quality microphone or need stereo for a specific use case
	autoGainControl      : true,
	echoCancellation     : true,
	noiseSuppression     : true,
	cursor               : 'always', // Ensures cursor visibility
	displaySurface       : 'monitor', // Capture full display
	screenShareFrameRate : { ideal: 15, max: 15 }, // Smooth frame rate for screen share
	screenShareHeight    : { ideal: 720, max: 1080 }, // Full HD resolution
	screenShareWidth     : { ideal: 1280, max: 1920 }
};

const useCallHelper = (peerConnectionRef, remoteStreamRef, localStreamRef, reconectionRef) =>
{
	const userData = useSelector((state) => state?.mysession?.session);
	const { callDetails, userStatus } = useSelector((state) => state?.mypresence);
	const [ showOverLay, setShowOverLay ] = useState(false);
	const dispatch = useDispatch();
	const reconnectionTimer = useRef();
	const blockHandleAccept = useRef();
	const offerTimeoutRef = useRef();
	const closeTimer = useRef();
	const peerConnectionTimer = useRef();

	let videoStream;
	let audioStream;
	const stopVideoStream = () =>
	{
		if (localStreamRef?.current)
		{
			localStreamRef.current.getTracks().forEach((track) => track.stop());
			localStreamRef.current = null;
		}

		if (remoteStreamRef?.current)
		{
			remoteStreamRef.current.getTracks().forEach((track) => track.stop());
			remoteStreamRef.current = null;
		}

		if (videoStream)
		{
			videoStream?.getTracks().forEach((track) => track.stop());
		}
		if (audioStream)
		{
			audioStream?.getTracks().forEach((track) => track.stop());
		}
	};

	const setUserStatusOnline = async () =>
	{
		const statusData = {
			status    : 'online',
			timestamp : Date.now()
		};

		await updateDeviceData(statusData, userData?.userId);
	};

	const answerCall = async (callDetails) =>
	{
		const answerDescription = await peerConnectionRef.current?.createAnswer();

		await peerConnectionRef.current.setLocalDescription(answerDescription);

		const answer = {
			type : answerDescription.type,
			sdp  : answerDescription.sdp
		};

		console.log('answer===========>', answer, peerConnectionRef.current, callDetails);

		await updateDocByDocumentId('signalling', callDetails?.callId, { answer });
	};

	const setBandwidthConstraints = () =>
	{
		const senders = peerConnectionRef.current?.getSenders();

		if (senders)
		{
			senders.forEach((sender) =>
			{
				if (sender.track.kind === 'video')
				{
					const parameters = sender.getParameters();

					if (!parameters.encodings)
					{
						parameters.encodings = [ {} ];
					}
					parameters.encodings[0].minBitrate = 256000; // 256 kbps
					parameters.encodings[0].maxBitrate = 1024000; // 1024 kbps

					sender.setParameters(parameters)
						.then(() =>
						{
							// Bandwidth parameters set successfully
						})
						.catch((error) =>
						{
							console.error('Error setting bandwidth parameters:', error);
						});
				}
			});
		}
	};

	const updateMic = async ({ isInitiator = false, isReciver = false, selectedDeviceId = null }) =>
	{
		try
		{
			let deviceId = selectedDeviceId;

			// Generate a new audio track with specified constraints
			audioStream = await navigator.mediaDevices.getUserMedia({
				audio : {
					deviceId         : { ideal: deviceId },
					channelCount     : config.channelCount,
					autoGainControl  : config.autoGainControl,
					echoCancellation : config.echoCancellation,
					noiseSuppression : config.noiseSuppression
				}
			});

			if (!selectedDeviceId)
			{
				const audioDevices = await getConectedDevices('audioinput');

				dispatch(setConnectedDevices(audioDevices));

				deviceId = audioDevices?.[0]?.deviceId;

				dispatch(setselectedDeviceId(deviceId));
			}

			if (closeTimer.current)
			{
				setShowOverLay(false);
				clearTimeout(closeTimer.current);
			}

			const audioTrack = audioStream.getAudioTracks()[0];

			audioTrack.onended = () =>
			{
				localStreamRef?.current?.getTracks().forEach((track) =>
				{
					if (track.kind === 'audio')
					{
						track.stop();
						localStreamRef.current.removeTrack(track);
						dispatch(setAudioInProgress(false));
					}
				});
			};

			// Stop any existing audio track before adding the new one
			localStreamRef?.current?.getTracks().forEach((track) =>
			{
				if (track.kind === 'audio')
				{
					track.stop();
					localStreamRef.current.removeTrack(track);
				}
			});

			// Add the new audio track to the local stream
			localStreamRef?.current?.addTrack(audioTrack);

			// Replace the audio track in the peer connection if it exists
			const sender = peerConnectionRef.current
				?.getSenders()
				.find((sender) => sender.track?.kind === 'audio');

			if (sender)
			{
				sender.replaceTrack(audioTrack);
				dispatch(setAudioInProgress(true));
			}
			else
			{
				peerConnectionRef.current.addTrack(audioTrack, localStreamRef?.current);
				dispatch(setAudioInProgress(true));
			}

			return { isGenrateAudiostream: true, audioError: null };
		}
		catch (error)
		{
			console.error('Error generating audio track:', error, audioStream);

			if (audioStream)
			{
				audioStream?.getTracks().forEach((track) => track.stop());
			}

			dispatch(setAudioInProgress(false));

			if (closeTimer.current)
			{
				setShowOverLay(false);
				clearTimeout(closeTimer?.current);
			}

			// Stop any existing audio tracks on error
			if (localStreamRef?.current)
			{
				localStreamRef?.current.getTracks().forEach((track) =>
				{
					if (track.kind === 'audio') track.stop();
				});
			}

			// handleError(error);

			if (isInitiator || isReciver)
			{
				return { isGenrateAudiostream: false, audioError: error };
			}

			return { isGenrateAudiostream: true, audioError: error }; // Return true even if error, to avoid blocking further actions
		}
	};

	const handleAudioOff = async (isMute) =>
	{
		const audioTracks = localStreamRef.current?.getAudioTracks();

		if ((audioTracks && audioTracks?.length === 0) || !audioTracks)
		{
			try
			{
				const { isGenrateAudiostream, audioError } = await updateMic({ isInitiator: true });

				if (!isGenrateAudiostream)
				{
					dispatch(setAudioInProgress(false));
					updateDocByDocumentId('messages', callDetails?.callId, { [`callDetails.participants.${userData.userId}.isAudioMuted`]: false });
					// handleError(audioError, 'audio');
				}
			}
			catch (error)
			{
				dispatch(setAudioInProgress(false));
				updateDocByDocumentId('messages', callDetails?.callId, { [`callDetails.participants.${userData.userId}.isAudioMuted`]: false });
				// handleError(error);
			}
		}
		else
		{
			localStreamRef.current?.getTracks().forEach((t) =>
			{
				if (t.kind === 'audio')
				{
					t.enabled = isMute;
				}
			});

			dispatch(setAudioInProgress(isMute));
			updateDocByDocumentId('messages', callDetails?.callId, { [`callDetails.participants.${userData.userId}.isAudioMuted`]: !isMute });
		}
	};

	const updateWebCam = async ({ isInitiator = false, isReciver = false, selectedDeviceId = null }) =>
	{
		try
		{
			let deviceId = selectedDeviceId;

			const videoConstraints = {
				video : {
					width       : { min: 640, ideal: 1280, max: 1920 },
					height      : { min: 360, ideal: 720, max: 1080 },
					frameRate   : { ideal: 30, max: 60 },
					facingMode  : { ideal: 'user' }, // Switch to 'environment' for rear camera
					deviceId    : deviceId ? { exact: deviceId } : undefined, // Camera selection
					aspectRatio : 16 / 9, // Optional aspect ratio
					resizeMode  : 'crop-and-scale',
					advanced    : [ { aspectRatio: 16 / 9 } ]
				}
			};

			// Request new video track
			videoStream = await navigator.mediaDevices.getUserMedia(videoConstraints);

			if (!selectedDeviceId)
			{
				const coneectedWebCams = await getConectedDevices('videoinput');

				dispatch(setConnectedVideoDevices(coneectedWebCams));

				deviceId = coneectedWebCams?.[0]?.deviceId;

				dispatch(setSelectedVideoDeviceId(deviceId));
			}

			if (closeTimer.current)
			{
				setShowOverLay(false);
				clearTimeout(closeTimer?.current);
			}

			const videoTrack = videoStream?.getVideoTracks()[0];

			videoTrack.onended = () =>
			{
				videoTrack.stop();
				localStreamRef?.current?.getTracks().forEach((track) =>
				{
					if (track.kind === 'video')
					{
						track.stop();
						localStreamRef.current.removeTrack(track);
						dispatch(setWebcamInProgress(false));
					}
				});
			};

			// Replace the existing video track if present
			localStreamRef?.current?.getTracks().forEach((track) =>
			{
				if (track.kind === 'video')
				{
					track.stop();
					localStreamRef.current.removeTrack(track);
				}
			});

			// Add new video track to the local stream
			localStreamRef?.current?.addTrack(videoTrack);

			// Replace the track in the peer connection
			const senders = peerConnectionRef.current?.getSenders();
			const videoSender = senders?.find((sender) => sender.track?.kind === 'video');

			if (videoSender)
			{
				videoSender.replaceTrack(videoTrack);
				dispatch(setWebcamInProgress(true));
			}
			else
			{
				peerConnectionRef.current?.addTrack(videoTrack, localStreamRef?.current);

				dispatch(setWebcamInProgress(true));
			}

			return { isGenrateVideostream: true, videoError: null };
		}
		catch (err)
		{
			console.error('Error producing video stream:', err);

			dispatch(setWebcamInProgress(false));

			if (closeTimer.current)
			{
				setShowOverLay(false);
				clearTimeout(closeTimer?.current);
			}

			// Stop any remaining video tracks on error
			if (localStreamRef?.current)
			{
				localStreamRef?.current.getTracks()
					.forEach((track) => track.kind === 'video' && track.stop());
			}

			// handleError(err); // Custom error handler

			if (isInitiator || isReciver)
			{
				return { isGenrateVideostream: false, videoError: err };
			}

			return { isGenrateVideostream: true, videoError: err }; // Fallback for non-critical errors
		}
	};

	const updateCallCamera = async (isMute) =>
	{
		try
		{
			if (!isMute)
			{
				localStreamRef.current.getVideoTracks().forEach((track) =>
				{
					track.stop();
					localStreamRef.current.removeTrack(track);
				});
			}
			else
			{
				const { isGenrateVideostream, videoError } = await updateWebCam({ isInitiator: true });

				if (!isGenrateVideostream)
				{
					// handleError(videoError, 'video');

					return;
				}
			}

			dispatch(setWebcamInProgress(isMute));
			updateDocByDocumentId('messages', callDetails?.callId, { [`callDetails.participants.${userData.userId}.isVideoPaused`]: !isMute });
		}
		catch (error)
		{
			console.log('Error in updateCallCamera:', error);
		}
	};

	const peerConnectionClose = (id) =>
	{
		if (peerConnectionRef.current && id === store.getState()?.mypresence?.callDetails?.callId)
		{
			dispatch(setConnectionState(''));
			peerConnectionRef.current.close();
			peerConnectionRef.current = null;
		}

		if (offerTimeoutRef.current)
		{
			clearTimeout(offerTimeoutRef.current);
			offerTimeoutRef.current = null;
		}

		dispatch(setAudioInProgress(false));
		dispatch(setWebcamInProgress(false));

		store.getState()?.call?.audioCall && dispatch(setAudioCall(''));
		store.getState()?.call?.videoCall && dispatch(setVideoCall(''));
		store.getState()?.call?.roomModeView !== 'democratic' && dispatch(setRoomModeView('democratic'));

		stopVideoStream();
		reconectionRef.current = false;
	};

	const setupPeerConnection = async ({ isOffer, callType, callDetails }) =>
	{
		if (peerConnectionRef.current)
		{
			peerConnectionRef.current.close();
			peerConnectionRef.current = null;
		}

		try
		{
			// Create local stream with audio and multiple video tracks
			localStreamRef.current = new MediaStream();
			remoteStreamRef.current = new MediaStream();

			const pc = new RTCPeerConnection(configuration);

			peerConnectionRef.current = pc;

			pc.ontrack = (event) =>
			{
				event.streams[0].getTracks().forEach((track) =>
				{
					if (!remoteStreamRef.current.getTracks().includes(track))
					{
						remoteStreamRef.current.addTrack(track);
					}
				});
				if (event.track.kind === 'audio')
				{
					const audioStream = new MediaStream([ event.track ]);

					// Find or create an audio element
					let audioElement = document.getElementById('remoteAudio');

					if (!audioElement)
					{
						audioElement = document.createElement('audio');
						audioElement.id = 'remoteAudio';
						audioElement.autoplay = true;
						audioElement.controls = false;
						document.body.appendChild(audioElement);
					}

					// Attach the remote audio stream
					audioElement.srcObject = audioStream;
					audioElement.play()
						.then(() => console.log('Playing remote audio'))
						.catch((error) => console.error('Error playing audio:', error));
				}
			};

			pc.onicecandidate = (event) =>
			{
				if (event.candidate && callDetails && callDetails?.callId)
				{
					addDocToSubcollection('signalling', callDetails?.callId, 'candidates', { candidate: event.candidate.toJSON(), fromId: userData?.userId });
				}
			};

			let listenerRef = () => { };

			const attemptReconnect = async () =>
			{
				console.log('attemptReconnect==========>', callDetails);
				try
				{
					const body = { callType: callDetails?.isAudioCall ? 'audio' : 'video', callDetails };

					if (callDetails?.initiator === userData?.userId)
					{
						await updateDocAndDeleteSubcollection('signalling', callDetails?.callId, { offer: null, answer: null });
						const offer = await setupPeerConnection({ ...body, isOffer: 'offer' });

						await updateDocByDocumentId('signalling', callDetails?.callId, { offer });
					}
					else
					{
						listenerRef = calldbListener('signalling', callDetails?.callId, async (res) =>
						{
							if (!res?.answer && res?.offer && Object.keys(res?.offer).length > 0 && callDetails?.initiator !== userData.userId && peerConnectionRef.current)
							{
								listenerRef();
								await setupPeerConnection(body);
								await peerConnectionRef.current.setRemoteDescription(res?.offer);
								await answerCall(callDetails);
							}
						});
					}
				}
				catch (error)
				{
					console.log(`Error in restartIce: ${error}`);
				}
			};

			pc.onconnectionstatechange = () =>
			{
				console.log('connectionState', pc.connectionState);
				switch (pc.connectionState)
				{
					case 'connected':
						if (callDetails?.type === PRESENCE_ENUMS.individual)
						{
							// Update participant status, then check if both are connected
							updateDocByDocumentId('messages', callDetails?.callId, { [`callDetails.participants.${userData.userId}.status`]: PRESENCE_ENUMS.connected, updatedAt: new Date().valueOf() })
								.then(async () =>
								{
									const checkAndUpdate = async (retry = 0) =>
									{
										try
										{
											const callData = await getDocByDocumentId('messages', callDetails?.callId);

											const participants = Object.values(callData?.data()?.callDetails?.participants || {});
											const allConnected = participants.length === 2 && participants.every((p) => p?.status === PRESENCE_ENUMS.connected);

											if (allConnected)
											{
												await updateDocByDocumentId('messages', callDetails?.callId, { 'callDetails.status': PRESENCE_ENUMS.connected, updatedAt: new Date().valueOf() });
											}
										}
										catch (error)
										{
											console.error('Error checking call status:', error);
										}
									};

									setTimeout(() => checkAndUpdate(0), 200);
								})
								.catch((error) => console.error('Error updating participant status:', error));
						}
						else
						{
							updateDocByDocumentId('messages', callDetails?.callId, { [`callDetails.participants.${userData.userId}.status`]: PRESENCE_ENUMS.connected, 'callDetails.status': PRESENCE_ENUMS.connected, updatedAt: new Date().valueOf() });
						}
						reconectionRef.current = false;
						const deviceData = JSON.parse(sessionStorage.getItem('deviceData'));
						const statusData = {
							status       : 'inCall',
							timestamp    : deviceData?.timestamp,
							callId       : callDetails?.callId,
							// remoteUserId : deviceData?.remoteUserId
							remoteUserId : callDetails?.participants && Object.values(callDetails?.participants).find((user) => user?.id !== userData?.userId)?.id
						};

						console.log('Connected callDetails===========>', callDetails);

						updateDeviceData(statusData, userData?.userId);
						dispatch(setConnectionState(PRESENCE_ENUMS.connected));
						clearTimeout(reconnectionTimer.current); // Clear timeout if connected
						// Handle UI updates when call is connected
						break;

					case 'disconnected':
						dispatch(setConnectionState(''));
						reconectionRef.current = true;
						reconnectionTimer.current = setTimeout(async () =>
						{
							if (reconectionRef.current)
							{
								const deviceData = JSON.parse(sessionStorage.getItem('deviceData'));

								peerConnectionClose();
								setUserStatusOnline();
								const otherUserData = (await get(ref(firebaseRealtimeDB, `UserDeviceStatus/${deviceData?.remoteUserId}`))).val();

								// in server call status updated....

								const findEntryByCallId = (obj, targetCallId) =>
								{
									for (const [ key, value ] of Object.entries(obj))
									{
										if (value.callId === targetCallId)
										{
											return key;
										}
									}

									return null; // Return null if not found
								};

								const result = findEntryByCallId(otherUserData, callDetails?.callId);

								await removeUserOnlineStatus(deviceData?.remoteUserId, result);
							}
						}, 30000);

						if (localStreamRef?.current)
						{
							localStreamRef.current.getTracks().forEach(async (track) =>
							{
								track.stop(); // Stop the track
								localStreamRef.current.removeTrack(track); // Remove the track from the stream
							});
						}

						if (remoteStreamRef?.current)
						{
							remoteStreamRef.current.getTracks().forEach(async (track) =>
							{
								track.stop(); // Stop the track
								remoteStreamRef.current.removeTrack(track); // Remove the track from the stream
							});
						}

						attemptReconnect();
						// Handle reconnection attempts or UI alerts here
						break;

					case 'failed':
						console.error('Peer connection failed. Closing connection.');
						dispatch(setConnectionState(''));
						break;

					case 'closed':
						dispatch(setConnectionState(''));
						// Handle cleanup and UI updates
						break;

					default:
						break;
				}
			};

			blockHandleAccept.current = 'beforeStreamGenration';

			const { isGenrateAudiostream, audioError } = await updateMic({ isInitiator: isOffer });

			if (!store.getState().mypresence?.callDetails)
			{
				return 'cancel';
			}

			if (callType === 'video')
			{
				const { isGenrateVideostream, videoError } = await updateWebCam({ isInitiator: isOffer });

				if (!store.getState().mypresence?.callDetails)
				{
					return 'cancel';
				}

				setBandwidthConstraints();
				// if (audioError && videoError)
				// {
				// 	console.log('sadsdasdasdasdasdasda');
				// 	// handleError(videoError, 'both', true);
				// }
				// else if (videoError)
				// {
				// 	console.log('qwqewqewqewqeqwe');
				// 	// handleError(videoError, 'video', true);
				// }
				// else if (audioError)
				// {
				// 	// handleError(audioError, 'audio', true);
				// }

				if (!isGenrateVideostream || !isGenrateAudiostream)
				{
					blockHandleAccept.current = '';

					return;
				}
			}

			if (callType === 'audio')
			{
				// if (audioError)
				// {
				// 	console.log('aa dsadas');
				// 	// handleError(audioError, 'audio');
				// }
				if (!isGenrateAudiostream)
				{
					blockHandleAccept.current = '';

					return;
				}
			}

			blockHandleAccept.current = '';

			offerTimeoutRef.current = setTimeout(() =>
			{
				if (store.getState()?.mypresence?.callDetails?.participants[userData?.userId]?.status === PRESENCE_ENUMS.ringing)
				{
					setUserStatusOnline();
					offerTimeoutRef.current = null;
					peerConnectionClose(store?.getState()?.mypresence?.callDetails?.callId);
				}
			}, getTimeDifference(store?.getState()?.mypresence?.callDetails?.createdAt));

			dispatch(setCallInProgress(true));

			if (isOffer)
			{
				const offerDescription = await peerConnectionRef.current.createOffer({ iceRestart: true });

				await peerConnectionRef.current.setLocalDescription(offerDescription);
				const offer = {
					sdp  : offerDescription.sdp,
					type : offerDescription.type
				};

				return offer;
			}
			else
				if (!store.getState().mypresence?.callDetails)
				{
					return 'cancel';
				}
		}
		catch (err)
		{
			if (localStreamRef?.current)
			{
				localStreamRef.current.getTracks().forEach((track) => track.stop());
				localStreamRef.current = null;
			}

			if (videoStream)
			{
				videoStream?.getTracks().forEach((track) => track.stop());
			}
			if (audioStream)
			{
				audioStream?.getTracks().forEach((track) => track.stop());
			}
		}
	};

	const updateCallStatus = async (apiBody, type) =>
	{
		try
		{
			const res = await updatePresenceStatus(apiBody);

			if (res)
			{
				if ([ PRESENCE_ENUMS.missed, PRESENCE_ENUMS.declined, PRESENCE_ENUMS.ended ].includes(res?.results?.highestPriority))
				{
					toast.warn('Oops! This call is no longer active.');

					if ([ 'inCall', PRESENCE_ENUMS.ringing ].includes(store.getState().mypresence.userStatus))
					{
						setUserStatusOnline();
					}
					peerConnectionClose(apiBody?.callId);
				}
				else
					if (apiBody?.isGroup)
					{
						let prevCallDetails = store.getState().mypresence.callDetails;
						let isChange = false;

						if (prevCallDetails && res?.results?.highestPriority && prevCallDetails?.status !== res?.results?.highestPriority)
						{
							prevCallDetails = {
								...prevCallDetails,
								status : res?.results?.highestPriority
							};
							isChange = true;
						}
						if (prevCallDetails && res?.results?.highestParticipantPriority && prevCallDetails?.participants[userData?.userId]?.status !== res?.results?.highestParticipantPriority)
						{
							prevCallDetails = {
								...prevCallDetails,
								participants : {
									...prevCallDetails.participants,
									[userData?.userId] : {
										...prevCallDetails.participants[userData?.userId],
										status : res?.results?.highestParticipantPriority
									}
								}
							};
							isChange = true;
						}

						if (isChange)
						{
							dispatch(setCallDetails({ ...prevCallDetails }));
						}
					}
			}
		}
		catch (err)
		{
			console.log('error=====', err);
			if (apiBody?.status === PRESENCE_ENUMS.ringing)
			{
				await updateDocByDocumentId('messages', apiBody?.callId, { [`callDetails.participants.${userData.userId}.status`]: PRESENCE_ENUMS.ringing, 'callDetails.status': PRESENCE_ENUMS.ringing });
			}
			else if (apiBody?.status === PRESENCE_ENUMS.accepted)
			{
				await updateDocByDocumentId('messages', apiBody?.callId, { [`callDetails.participants.${userData.userId}.status`]: PRESENCE_ENUMS.accepted, 'callDetails.status': PRESENCE_ENUMS.accepted, 'callDetails.callStartTime': apiBody?.callStartTime, [`callDetails.participants.${apiBody?.initiator}.status`]: PRESENCE_ENUMS.accepted });
			}
		}
	};

	const checkHighPriority = (currentData) =>
	{
		const callStatus = [ PRESENCE_ENUMS.connecting, PRESENCE_ENUMS.ringing, PRESENCE_ENUMS.accepted, PRESENCE_ENUMS.connected, PRESENCE_ENUMS.missed, PRESENCE_ENUMS.declined, PRESENCE_ENUMS.ended ];

		const prevCallDetails = store.getState().mypresence.callDetails;
		const prevCallStatus = callStatus.indexOf(prevCallDetails?.status);

		const cutrrentCallStatus = callStatus.indexOf(currentData?.status);

		if (!prevCallDetails)
		{
			return;
		}

		if (cutrrentCallStatus >= prevCallStatus)
		{
			dispatch(setCallDetails(currentData));
		}
	};

	const setUpGroupCallInfo = async (sts, callInfoData, isRinging = false) =>
	{
		try
		{
			const user = callInfoData?.participants?.[userData?.userId];

			let callStatus = callInfoData?.status;

			switch (sts)
			{
				case PRESENCE_ENUMS.declined:
					const outGoinAudioCall = [ PRESENCE_ENUMS.initiated, PRESENCE_ENUMS.outGoing ].includes(store.getState()?.call?.audioCall);
					const outGoingVideoCall = [ PRESENCE_ENUMS.initiated, PRESENCE_ENUMS.outGoing ].includes(store.getState()?.call?.videoCall);

					// remove this code and check
					if (callInfoData?.initiator === userData?.userId && (outGoinAudioCall || outGoingVideoCall))
					{
						callStatus = sts;
						const body = {
							userId    : userData?.userId,
							messageId : callInfoData?.callId,
							groupId   : callInfoData?.groupId
						};

						body.peerIds = Object.keys(callInfoData?.participants).filter((peer, index) => peer !== userData?.userId && callInfoData?.participants[index]?.status !== PRESENCE_ENUMS?.missed);
						declineGroupCallAPI(body).then((res) =>
						{
							// API call successful
						})
							.catch((err) =>
							{
								console.log('error=========', err);
							});

						// updateGroupMemberCallStatus(Object.values(callInfoData?.participants || {}), callInfoData?.callId, [PRESENCE_ENUMS.invited, PRESENCE_ENUMS.ringing]);
					}
					setUserStatusOnline();
					break;

				case PRESENCE_ENUMS.missed:
					if (callInfoData?.status === PRESENCE_ENUMS.ringing && callInfoData?.initiator === userData?.userId)
					{
						callStatus = sts;
					}
					if (callInfoData?.initiator === userData?.userId && !isRinging)
					{
						const body = {
							userId    : userData?.userId,
							messageId : callInfoData?.callId,
							groupId   : callInfoData?.groupId,
							peerIds   : Object.keys(callInfoData?.participants).filter((peer, index) => peer !== userData?.userId && callInfoData?.participants[index]?.status !== PRESENCE_ENUMS?.missed)

							// peerIds: Object.keys(callInfoData?.participants).filter((peer, index)=> peer !== userData?.userId && callInfoData?.participants[index]?.status !== PRESENCE_ENUMS?.missed)

						};

						declineGroupCallAPI(body).then((res) =>
						{
							// API call successful
						})
							.catch((err) =>
							{
								console.log('error===============', err);
							});

						// updateGroupMemberCallStatus(Object.values(callInfoData?.participants || {}), callInfoData?.callId, [PRESENCE_ENUMS.invited, PRESENCE_ENUMS.ringing]);
					}
					setUserStatusOnline();
					break;

				case PRESENCE_ENUMS.accepted:
					if (callInfoData?.status === PRESENCE_ENUMS.ringing || callInfoData?.status === PRESENCE_ENUMS.connecting)
					{
						callStatus = sts;
					}
					break;

				case PRESENCE_ENUMS.ringing:
					if (callInfoData?.status === PRESENCE_ENUMS.connecting)
					{
						callStatus = sts;
					}
					break;

				default:
					break;
			}

			const updatedParticipants = {
				...callInfoData.participants,
				[`${userData.userId}`] : { ...user, status: sts }
			};

			const body = {
				callId            : callInfoData?.callId,
				userId            : userData.userId,
				participantStatus : sts,
				isGroup           : callInfoData?.type === PRESENCE_ENUMS.group
			};
			// let updateDocumentBody = { [`callDetails.participants.${userData.userId}.status`]: sts }

			const updateCallDetailsBody = { participants: updatedParticipants };

			if (callStatus !== callInfoData?.status)
			{
				// updateDocumentBody['callDetails.status'] = callStatus;
				body.status = callStatus;
				updateCallDetailsBody.status = PRESENCE_ENUMS.ringing;
			}

			if ([ PRESENCE_ENUMS.accepted, PRESENCE_ENUMS.ringing ].includes(sts))
			{
				checkHighPriority({ ...callInfoData, ...updateCallDetailsBody });
			}
			else
			{
				dispatch(setCallDetails(null));
			}

			// await updateDocByDocumentId('messages', callInfoData?.callId, updateDocumentBody);

			await updateCallStatus(body, 'from handlecall');
		}
		catch (err)
		{
			console.log('error-------------', err);
		}
	};

	const setUpGroupData = async ({ type, callData, isRing = false }) =>
	{
		offerTimeoutRef.current = setTimeout(async () =>
		{
			const currentCallData = store.getState()?.mypresence?.callDetails;

			if (
				[ PRESENCE_ENUMS.ringing, PRESENCE_ENUMS.left, PRESENCE_ENUMS.declined, PRESENCE_ENUMS.missed ].includes(store.getState()?.mypresence?.callDetails?.participants[userData?.userId]?.status) &&
				callData?.callId === currentCallData?.callId
			)
			{
				type ? dispatch(setVideoCall('')) : dispatch(setAudioCall(''));
				setUpGroupCallInfo(PRESENCE_ENUMS.missed, store.getState()?.mypresence?.callDetails, isRing);

				setUserStatusOnline();
				offerTimeoutRef.current = null;
				// need to check and remove code
				peerConnectionClose(store.getState()?.mypresence?.callDetails?.callId);
			}

			// if (store.getState()?.userInfo?.callDetails?.status === PRESENCE_ENUMS.accepted && store.getState()?.userInfo?.userInfo?.userId === store.getState()?.userInfo?.callDetails?.initiator) {
			//   console.log('inside==================================================updateGroupMemberCallStatus=')
			//   // const participantDetails = { ...store.getState()?.userInfo?.callDetails?.participants }
			//   updateGroupMemberCallStatus(Object.values(store.getState()?.userInfo?.callDetails?.participants || {}), store.getState()?.userInfo?.callDetails?.callId, [PRESENCE_ENUMS.invited, PRESENCE_ENUMS.ringing]);
			// }
		}, getTimeDifference(isRing ? callData?.participants[userData?.userId]?.createdAt : callData?.createdAt));

		if (callData?.initiator !== userData?.userId || isRing)
		{
			const statusData = {
				status    : PRESENCE_ENUMS.ringing,
				timestamp : Date.now(),
				callId    : callData?.callId
			};

			await updateDeviceData(statusData, userData?.userId);

			setUpGroupCallInfo(PRESENCE_ENUMS.ringing, callData);
		}

		dispatch(setCallInProgress(true));

		if (type)
		{
			try
			{
				localStreamRef.current = await navigator.mediaDevices.getUserMedia({
					audio : true,
					video : true
				});

				if (!store.getState().mypresence.callDetails)
				{
					if (localStreamRef?.current)
					{
						localStreamRef.current.getTracks().forEach((track) => track.stop());
						localStreamRef.current = null;
					}
				}
			}
			catch (err)
			{
				console.log('Error in setUpGroupData:', err);
			}
		}
	};

	const handleCall = async (data) =>
	{
		const isIncomingCall = data.senderId !== userData?.userId;
		const aCall = store.getState().call.audioCall;
		const vCall = store.getState().call.videoCall;
		const prevCallDetails = store.getState().mypresence.callDetails;

		const deviceData = sessionStorage.getItem('deviceData');
		let parsedData;

		if (deviceData)
		{
			parsedData = JSON.parse(deviceData);
		}

		// add condtion for ringing
		// api side firebase transections
		if ([ PRESENCE_ENUMS.declined, PRESENCE_ENUMS.missed, PRESENCE_ENUMS.ended ].includes(data.callDetails?.status) && ((prevCallDetails && prevCallDetails?.callId === data.callDetails.callId) || !prevCallDetails))
		{
			peerConnectionClose(data?.callDetails?.callId);
			dispatch(setCallDetails(null));
			dispatch(setCallInProgress(false));
			setUserStatusOnline();

			return;
		}
		if ([ PRESENCE_ENUMS.aCall, PRESENCE_ENUMS.vCall ].includes(data.messageType) && data.callDetails && isIncomingCall && new Date().valueOf() < data?.callDetails?.createdAt + (40 * 1000))
		{
			const callType = data.messageType === PRESENCE_ENUMS.aCall ? 'audio' : 'video';

			if (data.callDetails.type === PRESENCE_ENUMS.individual && !(store.getState().mypresence?.userStatus === 'inCall' || parsedData?.userStatus === PRESENCE_ENUMS.ringing))
			{
				// check incoming popup sequence
				const callData = { ...data.callDetails, status: PRESENCE_ENUMS.ringing, participants: { ...data.callDetails.participants, [userData?.userId]: { ...data.callDetails.participants[userData?.userId], status: PRESENCE_ENUMS.ringing } } };

				dispatch(setCallDetails(callData));
				dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.incoming) : setVideoCall(PRESENCE_ENUMS.incoming));
				const statusData = {
					status    : PRESENCE_ENUMS.ringing,
					timestamp : Date.now(),
					callId    : data.callDetails?.callId
				};

				await updateDeviceData(statusData, userData?.userId);

				const body = {
					callId : data.callDetails?.callId, // message doc Id
					status : PRESENCE_ENUMS.ringing, // wtever u needed
					userId : userData.userId
				};

				await updateCallStatus(body, 'from handlecall');

				const peerConnectionStatus = await setupPeerConnection({ callType, callDetails: callData });

				if (peerConnectionStatus === 'cancel')
				{
					stopVideoStream();
					dispatch(setAudioInProgress(false));
					dispatch(setWebcamInProgress(false));
				}
			}
			else if (data.callDetails?.participants[userData?.userId] && !(store.getState().mypresence?.userStatus === 'inCall' || parsedData?.userStatus === PRESENCE_ENUMS.ringing))
			{
				dispatch(setCallDetails(data.callDetails));
				setUpGroupData({ type: data.messageType === PRESENCE_ENUMS.vCall, callData: data.callDetails });
				dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.incoming) : setVideoCall(PRESENCE_ENUMS.incoming));
			}
		}
		else if (data?.callDetails?.status === PRESENCE_ENUMS.accepted && new Date().valueOf() < (data?.callDetails?.participants[userData?.userId]?.createdAt + (40 * 1000)) && data?.callDetails?.participants[userData?.userId]?.status === PRESENCE_ENUMS.invited && data?.callDetails.type === PRESENCE_ENUMS.group && !(store.getState().mypresence?.userStatus === 'inCall' || parsedData?.userStatus === PRESENCE_ENUMS.ringing))
		{
			dispatch(setCallDetails(data.callDetails));
			setUpGroupData({ type: data.messageType === PRESENCE_ENUMS.vCall, callData: data.callDetails, isRing: true });
			dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.incoming) : setVideoCall(PRESENCE_ENUMS.incoming));
		}
	};

	const updateCallDetails = async (message, duration, data) =>
	{
		const body = {
			groupId         : data?.groupId,
			messageId       : data?.callId,
			userId          : userData.userId,
			peerId          : data && Object.values(data?.participants)?.find((user) => user?.id !== userData?.userId).id,
			duration,
			callEndTime     : new Date().valueOf(),
			status          : message,
			userLastMessage : data?.initiator === userData.userId ? 'No Answer' : `You missed ${data?.isAudioCall ? 'Audio' : 'Video'} call`,
			peerLastMessage : data?.initiator === Object.values(data?.participants)?.find((user) => user?.id !== userData?.userId).id ? 'No Answer' : `You missed ${data?.isAudioCall ? 'Audio' : 'Video'} call`
		};

		try
		{
			await updateCallDetailsAPI(body);
		}
		catch (e)
		{
			if ([ 'inCall', PRESENCE_ENUMS.ringing ].includes(userStatus))
			{
				setUserStatusOnline();
			}
		}
	};

	const retryPeerConnection = async (data) =>
	{
		const audioCall = store?.getState().call.audioCall;

		if (data?.data()?.offer && peerConnectionRef.current)
		{
			if (!peerConnectionRef.current?.remoteDescription)
			{
				peerConnectionRef.current.setRemoteDescription(data?.data()?.offer);
			}

			const answerDescription = await peerConnectionRef.current?.createAnswer();

			await peerConnectionRef.current.setLocalDescription(answerDescription);

			const answer = {
				type : answerDescription.type,
				sdp  : answerDescription.sdp
			};

			if (!data?.data()?.answer)
			{
				const statusData = {
					status       : 'inCall',
					timestamp    : Date.now(),
					callId       : callDetails?.callId,
					remoteUserId : callDetails?.initiator
				};

				await updateDocByDocumentId('signalling', callDetails?.callId, { answer });
				await updateDeviceData(statusData, userData?.userId);
				(audioCall === PRESENCE_ENUMS.incoming || audioCall === PRESENCE_ENUMS.onGoing) ? dispatch(setAudioCall(PRESENCE_ENUMS.onGoing)) : dispatch(setVideoCall(PRESENCE_ENUMS.onGoing));
				const data = { ...callDetails, status: PRESENCE_ENUMS.accepted, callStartTime: new Date().valueOf(), participants: { ...callDetails.participants, [userData?.userId]: { ...callDetails.participants[userData?.userId], status: PRESENCE_ENUMS.accepted }, [callDetails?.initiator]: { ...callDetails.participants[callDetails?.initiator], status: PRESENCE_ENUMS.accepted } } };

				dispatch(setCallDetails(data));
			}
			else
			{
				(audioCall === PRESENCE_ENUMS.incoming || audioCall === PRESENCE_ENUMS.onGoing) ? dispatch(setAudioCall('')) : dispatch(setVideoCall(''));
				peerConnectionClose(store.getState()?.mypresence.callDetails?.callId);
			}
		}
	};

	const handleAccept = async (isContinue = false) =>
	{
		try
		{
			if (store.getState()?.mypresence.callDetails?.type === PRESENCE_ENUMS.individual)
			{
				if (blockHandleAccept.current === 'beforeSignaling')
				{
					return;
				}

				// this block of code is for open background layer showing when allow popup prompt is opened
				if (blockHandleAccept.current === 'beforeStreamGenration')
				{
					clearTimeout(closeTimer.current);

					setShowOverLay(true);

					closeTimer.current = setTimeout(() =>
					{
						setShowOverLay(false);
					}, 10000);

					return;
				}

				blockHandleAccept.current = 'beforeStreamGenration';

				const audioTracks = localStreamRef?.current?.getAudioTracks();

				const videoTracks = localStreamRef?.current?.getVideoTracks();

				let isGenrateAudiostream = true; let audioError = null;
				let isGenrateVideostream = true; let videoError = null;

				// if no audio tracks need to genrate again audio tracks
				if (audioTracks && audioTracks?.length === 0)
				{
					const audioResult = await updateMic({ isReciver: true });

					isGenrateAudiostream = audioResult?.isGenrateAudiostream;
					audioError = audioResult?.audioError;
				}

				// if no video tracks need to genrate again video tracks
				if (!store.getState()?.mypresence.callDetails?.isAudioCall && videoTracks && videoTracks?.length === 0)
				{
					const result = await updateWebCam({ isReciver: true });

					isGenrateVideostream = result.isGenrateVideostream;
					videoError = result.videoError;
				}

				// showing error popup when stream producing fails
				// handleStreamErrors(audioError, videoError, isContinue);

				if (!isGenrateAudiostream || (!isGenrateVideostream && !isContinue))
				{
					blockHandleAccept.current = '';

					return;
				}

				store.getState()?.call?.audioCall === PRESENCE_ENUMS.incoming ? dispatch(setAudioCall(PRESENCE_ENUMS.onGoing)) : dispatch(setVideoCall(PRESENCE_ENUMS.onGoing));

				const body = {
					callId        : callDetails?.callId,
					status        : PRESENCE_ENUMS.accepted,
					callStartTime : new Date().valueOf(),
					userId        : userData.userId
				};

				const res = await updateCallStatus(body, 'from handle accepect');

				blockHandleAccept.current = 'beforeSignaling';

				let retryCount = 0;
				const attemptRetry = async () =>
				{
					if (!store.getState().mypresence.callDetails)
					{
						clearTimeout(peerConnectionTimer.current);

						return;
					}
					if (retryCount >= 5)
					{
						clearTimeout(peerConnectionTimer.current);
						if (store.getState().call.audioCall)
						{
							dispatch(setAudioCall(''));
							toast.warn('Oops! This call is no longer active.');
						}
						else if (store.getState().call.videoCall)
						{
							dispatch(setVideoCall(''));
							toast.warn('Oops! This call is no longer active.');
						}
						if ([ 'inCall', PRESENCE_ENUMS.ringing ].includes(store.getState().mypresence.userStatus))
						{
							setUserStatusOnline();
						}
						peerConnectionClose(store.getState()?.mypresence.callDetails?.callId);
						updateCallDetails(PRESENCE_ENUMS.missed, null, store.getState()?.mypresence?.callDetails);

						blockHandleAccept.current = '';

						return;
					}

					const data = await getDocByDocumentId('signalling', callDetails?.callId);

					if (data?.data()?.offer && peerConnectionRef.current)
					{
						retryPeerConnection(data);
						blockHandleAccept.current = '';
					}
					else
					{
						retryCount++;
						peerConnectionTimer.current = setTimeout(attemptRetry, 2000);
					}
				};

				attemptRetry();
			}
			else if (callDetails?.type === PRESENCE_ENUMS.group)
			{
				stopVideoStream();
				setUpGroupCallInfo(PRESENCE_ENUMS.accepted, store.getState()?.mypresence?.callDetails);
				store.getState().call.audioCall === PRESENCE_ENUMS.incoming ? dispatch(setAudioCall(PRESENCE_ENUMS.onGoing)) : dispatch(setVideoCall(PRESENCE_ENUMS.onGoing));
				const statusData = {
					status       : 'inCall',
					timestamp    : Date.now(),
					callId       : callDetails?.callId,
					remoteUserId : callDetails?.initiator
				};

				await updateDeviceData(statusData, userData?.userId);
			}

			clearTimeout(offerTimeoutRef.current);
			offerTimeoutRef.current = null;
		}
		catch (err)
		{
			console.log('error==========', err);
		}
	};

	const handleIceCandidateUpdate = async (data) =>
	{
		try
		{
		// Skip processing if the ICE candidate is from the current user
			if (data.fromId === userData.userId) return;

			const candidateData = data.candidate;

			// Create a new ICE candidate
			const iceCandidate = new RTCIceCandidate({
				candidate     : candidateData.candidate,
				sdpMid        : candidateData.sdpMid,
				sdpMLineIndex : candidateData.sdpMLineIndex
			});

			// Ensure the peer connection exists and has a valid signaling state
			if (peerConnectionRef.current)
			{
				const signalingState = peerConnectionRef.current.signalingState;

				if (signalingState === 'closed')
				{
					console.warn('connection closed');

					return;
				}

				if (peerConnectionRef.current.remoteDescription)
				{
					await peerConnectionRef.current.addIceCandidate(iceCandidate);
				}
				else
				{
					console.warn('Remote description is not set');
				}
			}
			else
			{
				console.warn('PeerConnection does not exist');
			}
		}
		catch (error)
		{
			console.error('Failed to handle ICE candidate update:', error.message || error, data);
		}
	};

	const callDbCallBack = (data) =>
	{
		const callData = store?.getState()?.mypresence?.callDetails;
		const aCall = store?.getState()?.call?.audioCall;
		const vCall = store?.getState()?.call.videoCall;

		const deviceData = sessionStorage.getItem('deviceData');
		let parsedData;

		if (deviceData)
		{
			parsedData = JSON.parse(deviceData);
		}

		if (!callData && aCall === '' && vCall === '' && new Date().valueOf() < (data?.callDetails?.participants[userData?.userId || '']?.createdAt + (40 * 1000)) && data?.callDetails?.participants[userData?.userId || '']?.status === PRESENCE_ENUMS.invited && data?.callDetails.type === PRESENCE_ENUMS.group && !(store.getState()?.mypresence?.userData?.userStatus === 'inCall' || parsedData?.userStatus === PRESENCE_ENUMS.ringing))
		{
			dispatch(setCallDetails(data?.callDetails));
			setUpGroupData({ type: data.messageType === PRESENCE_ENUMS.vCall, callData: data.callDetails, isRing: true });
			dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.incoming) : setVideoCall(PRESENCE_ENUMS.incoming));
		}
		else if (data?.callDetails && data?.callDetails?.callId === callData?.callId)
		{
			const { status } = data.callDetails;
			const isInitiator = data.senderId === userData.userId;

			checkHighPriority(data.callDetails);

			if (data?.callDetails.type === PRESENCE_ENUMS.individual)
			{
				switch (status)
				{
					case PRESENCE_ENUMS.ringing:
						if (isInitiator)
						{
							if ([ aCall, vCall ].includes(PRESENCE_ENUMS.initiated))
							{
								dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.outGoing) : setVideoCall(PRESENCE_ENUMS.outGoing));
							}
						}
						break;
					case PRESENCE_ENUMS.accepted:
					case PRESENCE_ENUMS.connected:
						if (isInitiator)
						{
							if ([ PRESENCE_ENUMS.connecting, PRESENCE_ENUMS.ringing, PRESENCE_ENUMS.connected ].includes(callData?.status) &&
													([ aCall, vCall ].includes(PRESENCE_ENUMS.outGoing) || [ aCall, vCall ].includes(PRESENCE_ENUMS.initiated)) &&
													![ aCall, vCall ].includes(PRESENCE_ENUMS.onGoing)
							)
							{
								clearTimeout(offerTimeoutRef.current);
								offerTimeoutRef.current = null;
								dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.onGoing) : setVideoCall(PRESENCE_ENUMS.onGoing));
							}
						}
						else
							if ([ aCall, vCall ].includes(PRESENCE_ENUMS.incoming) && [ PRESENCE_ENUMS.accepted, PRESENCE_ENUMS.connected, PRESENCE_ENUMS.declined ].includes(data?.callDetails?.participants[userData?.userId]?.status))
							{
								peerConnectionClose(data?.callDetails?.callId);
								dispatch(setCallDetails(null));
								dispatch(setCallInProgress(false));
								setUserStatusOnline();
							}
						break;

					case PRESENCE_ENUMS.declined:
					case PRESENCE_ENUMS.missed:
					case PRESENCE_ENUMS.ended:
						peerConnectionClose(data?.callDetails?.callId);
						dispatch(setCallDetails(null));
						dispatch(setCallInProgress(false));
						setUserStatusOnline();
						break;
					default:
						break;
				}

				if (data.callDetails?.screenShareId)
				{
					if (store?.getState()?.call?.roomModeView === 'democratic')
					{
						dispatch(setRoomModeView('screenShare'));
					}
				}
				else
					if (store?.getState()?.call?.roomModeView === 'screenShare')
					{
						dispatch(setRoomModeView('democratic'));
					}
			}
			else if (data?.callDetails.type === PRESENCE_ENUMS.group)
			{
				switch (status)
				{
					case PRESENCE_ENUMS.connecting:
					case PRESENCE_ENUMS.ringing:
						if (
							data.callDetails &&
													data.callDetails.participants[userData?.userId] &&
													data.callDetails.participants[userData?.userId]?.status === PRESENCE_ENUMS.declined &&
													[ aCall, vCall ].includes(PRESENCE_ENUMS.incoming)
						)
						{
							peerConnectionClose(data?.callDetails?.callId);
							dispatch(setCallDetails(null));
							dispatch(setCallInProgress(false));
							setUserStatusOnline();
						}

						break;
					case PRESENCE_ENUMS.accepted:
						if (isInitiator)
						{
							if ([ PRESENCE_ENUMS.connecting, PRESENCE_ENUMS.ringing ].includes(callData?.status) &&
													([ aCall, vCall ].includes(PRESENCE_ENUMS.outGoing) || [ aCall, vCall ].includes(PRESENCE_ENUMS.initiated)) &&
													![ aCall, vCall ].includes(PRESENCE_ENUMS.onGoing)
							)
							{
								dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.onGoing) : setVideoCall(PRESENCE_ENUMS.onGoing));
								setUpGroupCallInfo(PRESENCE_ENUMS.accepted, data.callDetails);
								if (data.messageType === PRESENCE_ENUMS.vCall)
								{
									stopVideoStream();
									if (offerTimeoutRef.current)
									{
										clearTimeout(offerTimeoutRef.current);
										offerTimeoutRef.current = null;
									}
								}
							}
							else if (
								new Date().valueOf() < (data?.callDetails?.participants[userData?.userId]?.createdAt + (40 * 1000)) &&
													data?.callDetails?.participants[userData?.userId]?.status === PRESENCE_ENUMS.invited &&
													!(store.getState()?.mypresence?.userData?.userStatus === 'inCall' || parsedData?.userStatus === PRESENCE_ENUMS.ringing)
							)
							{
								setUpGroupData({ type: data.messageType === PRESENCE_ENUMS.vCall, callData: data.callDetails, isRing: true });
								dispatch(data.messageType === PRESENCE_ENUMS.aCall ? setAudioCall(PRESENCE_ENUMS.incoming) : setVideoCall(PRESENCE_ENUMS.incoming));
							}
							// Handles cases where a user joins a group call from the web but gets stuck on the loading page.
							// If the user remains stuck for 40 seconds, their status is updated to "missed,"
							// and they are moved to the presence list.
							else if ([ aCall, vCall ].includes(PRESENCE_ENUMS.onGoing) && [ PRESENCE_ENUMS.missed, PRESENCE_ENUMS.declined, PRESENCE_ENUMS.left ].includes(data?.callDetails?.participants[userData?.userId]?.status))
							{
								peerConnectionClose(data?.callDetails?.callId);
								dispatch(setCallDetails(null));
								dispatch(setCallInProgress(false));
								setUserStatusOnline();
							}
						}
						else
							if ([ aCall, vCall ].includes(PRESENCE_ENUMS.incoming) && [ PRESENCE_ENUMS.accepted, PRESENCE_ENUMS.connected, PRESENCE_ENUMS.declined ].includes(data?.callDetails?.participants[userData?.userId]?.status))
							{
								peerConnectionClose(data?.callDetails?.callId);
								dispatch(setCallDetails(null));
								dispatch(setCallInProgress(false));
								setUserStatusOnline();
							}
						if (localStreamRef?.current)
						{
							localStreamRef.current.getTracks().forEach((track) => track.stop());
							localStreamRef.current = null;
						}

						break;
					case PRESENCE_ENUMS.declined:
					case PRESENCE_ENUMS.ended:
					case PRESENCE_ENUMS.missed:
						peerConnectionClose(data?.callDetails?.callId);
						dispatch(setCallDetails(null));
						dispatch(setCallInProgress(false));
						setUserStatusOnline();
						break;
					default:
						break;
				}
			}
		}
	};

	return { setupPeerConnection, peerConnectionClose, handleCall, updateCallDetails, setUserStatusOnline, handleAccept, callDbCallBack, handleIceCandidateUpdate, handleAudioOff, updateCallCamera, setUpGroupCallInfo };
};

export default useCallHelper;